module.exports = __webpack_public_path__ + "media/images/avatars/default-9b26368821f0dfde74df6a7a5ab78752.png";